'use strict';

module.exports = require('./Dominus.prototype');



/*****************
 ** WEBPACK FOOTER
 ** ./~/dominus/src/dominus.js
 ** module id = 23
 ** module chunks = 0
 **/